module.exports = __webpack_public_path__ + "img/bg.8f0d5efe.png";